import { render, staticRenderFns } from "./PaymentInstructions.vue?vue&type=template&id=0e44c8e6&scoped=true&"
var script = {}
import style0 from "./PaymentInstructions.vue?vue&type=style&index=0&id=0e44c8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e44c8e6",
  null
  
)

export default component.exports